<template>
  <router-link :to="`/trip/${trip.id}/overview`" class="trip-card card">
    <div class="cover">{{ trip.coverEmoji }}</div>
    <div class="body">
      <div class="row-top">
        <span class="name">{{ trip.name }}</span>
        <StageTag :stage="stage" />
      </div>
      <div class="muted">
        {{ trip.destinations.join(' · ') || '目的地未定' }}
        <template v-if="trip.startDate">· {{ trip.startDate }} ~ {{ trip.endDate }}</template>
      </div>
      <div class="row-bottom">
        <MemberStack :members="members" :size="20" />
        <div class="tags">
          <span v-for="t in trip.tags.slice(0, 3)" :key="t" class="tag-chip">{{ t }}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
import StageTag from './StageTag.vue'
import MemberStack from '@/components/common/MemberStack.vue'

export default {
  name: 'TripCard',
  components: { StageTag, MemberStack },
  props: {
    trip: { type: Object, required: true }
  },
  computed: {
    ...mapGetters({ tripStage: 'tripStage', membersByTrip: 'members/byTrip' }),
    stage () {
      return this.tripStage(this.trip.id)
    },
    members () {
      return this.membersByTrip(this.trip.id)
    }
  }
}
</script>

<style scoped>
.trip-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 12px;
}
.cover {
  width: 52px;
  height: 52px;
  border-radius: var(--radius-md);
  background: #fff2ea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
}
.body {
  flex: 1;
  min-width: 0;
}
.row-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.name {
  font-weight: 700;
  font-size: 15px;
}
.row-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}
.tags { display: flex; gap: 4px; }
</style>
